(function () {
    'use strict';

    angular
        .module('franchisee-portal.directives')
        .directive('banners', Banners)

    /** @ngInject */
    function Banners($rootScope, HelperService, $location, $window, AuthenticationService, BannerService, DATA_EVENTS, PATHS) {
        function BannersController($scope) {
            const vm = this;

            vm.getBannerImage = banner => {
                return HelperService.imageResizePath('banner', banner.Id, banner.Image, 825, 400);
            }

            vm.onBannerClick = banner => {
                if (banner.ButtonText)
                    return;

                if (banner.NewWindow)
                    $window.open(banner.Link, '_blank');
                else
                    $location.path(banner.Link);
            }

            let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_UNIT_CHANGE, () => {
                init();
            })

            $scope.$on('$destroy', () => {
                removeWatchUnit();
            })

            init();

            function getBanners() {
                HelperService.startLoading('.banner');

                vm.isLoading = true;
                let userData = AuthenticationService.getUserData();

                BannerService
                    .getAllByParameters({
                        ResponsibilityId: userData.Responsibility.Id,
                        Active: true,
                        Highlight: true,
                        OrderBy: 'RegistrationDate',
                        OrderDescending: true
                    })
                    .then(success => {
                        vm.isLoading = false;
                        vm.banners = success.Banners;
                        HelperService.stopLoading('.banner');
                    }, error => {
                        vm.isLoading = false;
                        HelperService.errorCallback(error);
                        HelperService.stopLoading('.banner');
                    })
            }

            function init() {
                vm.isLoading = true;
                vm.banners = [];

                getBanners();
            }
        }

        return {
            bindToController: true,
            controller: BannersController,
            controllerAs: 'vm',
            restrict: 'AE',
            templateUrl: `${PATHS.PHYSICAL}/directives/banners/banners.html`,
            scope: {}
        }
    }
}());